import React from 'react'
import { ReactComponent as Logo } from 'assets/gamblersconcierge-logo-vertical-white.svg'

export default function GCTextIcon(props: any) {
  return (
    <Logo {...props} />
  )
}